"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const Client = require("./Client.cjs");
const createClient = (repositoryNameOrEndpoint, options) => new Client.Client(repositoryNameOrEndpoint, options);
exports.createClient = createClient;
//# sourceMappingURL=createClient.cjs.map
